// startup
// Load entry module and return exports
// This entry module doesn't tell about it's top-level declarations so it can't be inlined
__webpack_require__(5088);
var __webpack_exports__ = __webpack_require__(2021);
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
